import withAuth from "middlewares/withAuth";
import type { FC } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import {
  adminPrivateRoutes,
  paths,
  publicRoutes,
  rolePermission,
} from "./routesConfig";
import { useAppSelector } from "store";

import NotFoundPage from "pages/notFound/NotFoundRoutePage";

const PageRouter: FC = () => {
  const accessToken = useAppSelector((state) => state.auth.accessToken);

  const redirectTo = accessToken === null ? paths.signIn : paths.dashboard;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={paths.root}
          element={<Navigate to={redirectTo} replace />}
        />

        <Route element={<SignInRoute accessToken={accessToken} />}>
          {publicRoutes.map((route) => (
            <Route {...route} />
          ))}
        </Route>

        <Route element={<AdminAuthenticatedRoute accessToken={accessToken} />}>
          
          {adminPrivateRoutes.map((route) => {
            const canAccess = rolePermission(accessToken, route);

            if (canAccess) {
              return <Route {...route} element={<NotFoundPage />} />;
            }

            return <Route {...route} />;
          })}
        </Route>

        <Route path="*" element={<Navigate to={paths.root} replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default PageRouter;

export interface AuthenticateUserProps {
  accessToken?: string | null;
}

export interface AuthenticateUserRoleProps extends AuthenticateUserProps {
  userRole?: string | null;
}

const SignInRoute = ({ accessToken }: AuthenticateUserProps) => {
  if (accessToken !== null) {
    return <Navigate to={paths.root} replace />;
  }

  return <Outlet />;
};

const AdminAuthenticatedRoute = withAuth(
  ({ accessToken }: AuthenticateUserRoleProps) => {
    if (accessToken === null) {
      
      return <Navigate to={paths.signIn} replace />;
    }

    return <Outlet />;
  }
);
